// extracted by mini-css-extract-plugin
export default {"spin":"CandidateAttachment_spin__FY4XM","modal":"CandidateAttachment_modal__JRXx1","collapse":"CandidateAttachment_collapse__ca60b"};